import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeadersService } from './http-headers.service';
import { BalanceResponseDTO } from '../models/BalanceResponseDTO';
import { BalanceRequestDTO } from '../models/BalanceRequestDTO';
import { Urls } from '../utilities/urls.component';
import { BalanceDetailsResponseDTO } from '../models/BalanceDetailsResponseDTO';
import { Subject } from 'rxjs';

@Injectable()
export class BalanceService {
  balancesubject = new Subject();
  // API_ENDPOINT:string;
  constructor(private http: HttpClient, private headers: HttpHeadersService) {
    // this.API_ENDPOINT=localStorage.getItem("ENDPOINT");
  }

  getBalanceList(request: BalanceRequestDTO) {
    var url: string = Urls.API_V2_ENDPOINT + Urls.BALANCES.getAllBalance;
    return this.http.post<BalanceResponseDTO>(url, request, this.headers.getCommonHttpHeaders('v2_api'));
  }

  getBalanceById(request: BalanceRequestDTO) {
    var url: string = Urls.API_ENDPOINT + Urls.BALANCES.getAllBalanceById;
    return this.http.post<BalanceDetailsResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
  }

  exportBalance(request: BalanceRequestDTO) {
    var url: string = Urls.API_ENDPOINT + Urls.EXPORTAS.balanceExcelExport;
    return this.http.post<any>(url, request, this.headers.getCommonHttpHeaders());
  }

  getBalanceListById(request: BalanceRequestDTO){
    var url: string = Urls.API_V2_ENDPOINT + Urls.BALANCES.getBalanceListById;
    return this.http.post<BalanceResponseDTO>(url, request, this.headers.getCommonHttpHeaders('v2_api'));
    }
    getExportDataOnBalance(request: BalanceRequestDTO) {
      var url: string = Urls.API_V2_ENDPOINT + Urls.BALANCES.getExportDataOnBalance;
      return this.http.post<BalanceResponseDTO>(url, request, this.headers.getCommonHttpHeaders('v2_api'));
    }

}
